import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Fetch from "../../common/utils/Fetch";
import { ItemResource } from "./ItemResource";
import { Pagination } from "./Pagination";
import IResultItem from "./IResultItem";

import "./index.css";

interface IProps {
	query: string,
	pageSize: number,
	onRefresh: string,
}

interface IState {
	page: number,
	items: IResultItem[],
}

export class SearchResources extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);
		this.state = {
			page: 0,
			items: [],
		}
	}

	componentDidMount() {
		Fetch.get<any>("/IssueResources/Search", { q: this.props.query })
			.then(result => {
				this.setState({
					items: result,
				});

				window[this.props.onRefresh](result.length)
			})
			.catch(error => {
				console.error(error);
			});
	}

	onChangePage(page: number) {
		this.setState({ page: page});
	}

	handleLoadMore(item: IResultItem) {
		item.loading = true;
		this.setState({ items: this.state.items });
		let skip = 0;
		if (item.Issues) {
			skip = item.Issues.length;
		}

		Fetch.get<any>("/IssueResources/GetIssues", { resourceId: item.ResourceId, take: 20, skip: skip })
			.then(result => {
				var currentItem = this.getItem(item.ResourceId);
				currentItem.loading = false;
				var issues = (currentItem.Issues || []).concat(result);
				currentItem.Issues = issues;
				this.setState({ items: this.state.items });
			})
			.catch(error => {
				console.error(error);
			});
	}

	getItem(resourceId: string): IResultItem {
		for (var i = 0; i < this.state.items.length; i++) {
			var stateItem = this.state.items[i];
			if (stateItem.ResourceId == resourceId) {
				return stateItem;
			}
		}
	}

	render() {
		var skip = this.state.page * this.props.pageSize;
		var currentPage = this.state.items.slice(skip, skip + this.props.pageSize);
		return <div className="react-search-resources">
			{currentPage.map((item: IResultItem) => {
				return <ItemResource key={item.ResourceId} item={item} onRequestLoad={this.handleLoadMore.bind(this)} />
			})}

			<Pagination itemsPerPage={this.props.pageSize} maxItems={this.state.items.length} currentPage={this.state.page} callback={this.onChangePage.bind(this)} />
		</div>
	}
}

let content = document.getElementById("react-searchResources");
if (content) {
	ReactDOM.render(<SearchResources
		query={content.dataset.query}
		pageSize={parseInt(content.dataset.pageSize)}
		onRefresh={content.dataset.onRefresh}
	/>, content)
}
